module.exports = __webpack_public_path__ + "da6ed19504f333addbd60c9cef3828ce.gif";